module.exports = __webpack_public_path__ + "static/img/3_1_5_2.a978b852.jpg";